import template from './home.html';
import controller from './home.controller';
import './home.scss';

let homeComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$interval', 'donationsService'];

export default homeComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/home.component.js